import { useContext } from "react";

import {
  MultipleLocContext,
  type MultipleLocReturn,
} from "../contexts/MultipleLocContext";

export const useMultipleLocModal = (): MultipleLocReturn => {
  const context = useContext(MultipleLocContext);
  if (!context) {
    throw new Error(
      "useMultipleLocModal must be used within a MultipleLocProvider",
    );
  }
  return context;
};
